import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';



import AdminAccessPortal from '../../components/ui/AdminAccessPortal';
import GameControlInterface from '../../components/ui/GameControlInterface';
import RouletteWheel from './components/RouletteWheel';
import { loadConfiguration } from '../../utils/configService';




const RouletteGameScreen = () => {
  const navigate = useNavigate();
  const [isSpinning, setIsSpinning] = useState(false);
  const [currentPrize, setCurrentPrize] = useState(null);
  const [soundEnabled, setSoundEnabled] = useState(() => {
    const saved = localStorage.getItem('xaikus_sound_enabled');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [animationsEnabled, setAnimationsEnabled] = useState(() => {
    const saved = localStorage.getItem('xaikus_animations_enabled');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [mode, setMode] = useState('automatic');
  const [showAdminPortal, setShowAdminPortal] = useState(false);
  const [showGameControls, setShowGameControls] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [triggerSpin, setTriggerSpin] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [config, setConfig] = useState(() => loadConfiguration());

  useEffect(() => {
    localStorage.setItem('xaikus_sound_enabled', JSON.stringify(soundEnabled));
  }, [soundEnabled]);

  useEffect(() => {
    localStorage.setItem('xaikus_animations_enabled', JSON.stringify(animationsEnabled));
  }, [animationsEnabled]);

  useEffect(() => {
    const loadConfig = () => {
      const loadedConfig = loadConfiguration();
      setConfig(loadedConfig);
    };
    loadConfig();
    const handleStorageChange = (e) => {
      if (e?.key === 'xaikus_roulette_config') loadConfig();
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const activePrizes = config?.prizes?.filter(p => p?.enabled && p?.image) || [];

  const mockPrizes = [
    { id: 1, name: "Premio", description: "Lapicero de regalo", color: "#DC2626", probability: 10, icon: "gift", code: "CALOX-LAP-2026" },
    { id: 2, name: "Vuelve a girar", description: "¡Vuelve a intentarlo!", color: "#16A34A", probability: 10, icon: "gift", code: "CALOX-VG-2026" },
    { id: 3, name: "Gracias por participar", description: "Gracias por participar", color: "#2563EB", probability: 10, icon: "gift", code: "CALOX-GPP-2026" },
    { id: 4, name: "Premio", description: "Balón antiestrés de regalo", color: "#EA580C", probability: 10, icon: "gift", code: "CALOX-BAL-2026" },
    { id: 5, name: "Gracias por participar", description: "Gracias por participar", color: "#7C3AED", probability: 10, icon: "gift", code: "CALOX-GPP2-2026" },
    { id: 6, name: "Premio", description: "Destapador de regalo", color: "#EAB308", probability: 10, icon: "gift", code: "CALOX-DES-2026" },
    { id: 7, name: "Gracias por participar", description: "Gracias por participar", color: "#DC2626", probability: 10, icon: "gift", code: "CALOX-GPP3-2026" },
    { id: 8, name: "Premio", description: "Vaso de regalo", color: "#0891B2", probability: 10, icon: "gift", code: "CALOX-VAS-2026" },
    { id: 9, name: "Vuelve a girar", description: "¡Vuelve a intentarlo!", color: "#16A34A", probability: 10, icon: "gift", code: "CALOX-VG2-2026" },
    { id: 10, name: "Gracias por participar", description: "Gracias por participar", color: "#9333EA", probability: 10, icon: "gift", code: "CALOX-GPP4-2026" }
  ];

  const handleAuthenticate = async (credentials) => {
    if (credentials?.username === 'admin.xaikus' && credentials?.password === 'Xaikus2026!') {
      setIsAuthenticated(true);
      setShowGameControls(true);
      return true;
    }
    return false;
  };

  const handleSpinComplete = (prize) => {
    setCurrentPrize(prize);
    if (soundEnabled) console.log('🎵 Reproduciendo sonido de victoria');
  };

  const handleClosePrizeDisplay = () => setCurrentPrize(null);

  const handleModeChange = (newMode) => {
    setMode(newMode);
    if (newMode === 'assisted' && !showGameControls) setShowGameControls(true);
  };

  const handleManualSpin = () => {
    if (mode === 'assisted' && !isSpinning) setTriggerSpin(prev => !prev);
  };

  const handleSpinStart = () => console.log('🎡 Iniciando giro de ruleta');

  const handleAdminAccess = () => {
    if (isAuthenticated) navigate('/configuration-panel');
    else setShowAdminPortal(true);
  };

  const toggleSound = () => setSoundEnabled(prev => !prev);
  const toggleAnimations = () => setAnimationsEnabled(prev => !prev);

  const iconBtnSize = 'clamp(36px, 5vw, 72px)';
  const iconSize = Math.max(16, Math.round(window.innerWidth * 0.022));

  return (
    <div
      className="min-h-screen relative overflow-hidden"
      style={{ background: 'transparent' }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/20" />
      {/* Confetti */}
      {animationsEnabled && (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(50)]?.map((_, i) => (
            <div
              key={i}
              className="absolute animate-confetti"
              style={{
                left: `${Math.random() * 100}%`,
                top: `-${Math.random() * 20}%`,
                width: `${Math.random() * 10 + 5}px`,
                height: `${Math.random() * 10 + 5}px`,
                backgroundColor: ['#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6', '#EC4899']?.[Math.floor(Math.random() * 6)],
                opacity: Math.random() * 0.7 + 0.3,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${Math.random() * 3 + 4}s`,
                transform: `rotate(${Math.random() * 360}deg)`
              }}
            />
          ))}
        </div>
      )}
      {/* XAIKUS Header */}
      <div
        className="w-full shadow-lg relative z-10"
        style={{ padding: 'clamp(8px, 1.5vw, 24px) clamp(12px, 2vw, 32px)' }}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo and Title */}
          <div className="flex items-center" style={{ gap: 'clamp(10px, 2vw, 32px)' }}>
            <h1
              className="font-black italic tracking-wide leading-tight"
              style={{
                background: 'linear-gradient(90deg, #2dd4bf 0%, #ffffff 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontSize: 'clamp(13px, 2.6vw, 50px)',
                maxWidth: 'clamp(160px, 42vw, 680px)'
              }}
            >
              ¡Vive la emoción del mundial y gana!
            </h1>
          </div>

          {/* Header Controls */}
          <div className="flex items-center" style={{ gap: 'clamp(6px, 1vw, 16px)' }}>
            <button
              onClick={toggleSound}
              className="rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 active:bg-white/30 transition-all flex items-center justify-center touch-manipulation"
              style={{ width: iconBtnSize, height: iconBtnSize }}
              title={soundEnabled ? 'Desactivar sonido' : 'Activar sonido'}
            >
              <Icon name={soundEnabled ? 'Volume2' : 'VolumeX'} size={iconSize} className="text-white" />
            </button>
            <button
              onClick={toggleAnimations}
              className="rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 active:bg-white/30 transition-all flex items-center justify-center touch-manipulation"
              style={{ width: iconBtnSize, height: iconBtnSize }}
              title={animationsEnabled ? 'Desactivar animaciones' : 'Activar animaciones'}
            >
              <Icon name={animationsEnabled ? 'Sparkles' : 'SparklesIcon'} size={iconSize} className="text-white" />
            </button>
            <button
              onClick={handleAdminAccess}
              className="rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 active:bg-white/30 transition-all flex items-center justify-center opacity-0 hover:opacity-100 touch-manipulation"
              style={{ width: iconBtnSize, height: iconBtnSize }}
              title="Configuración administrativa"
            >
              <Icon name="Settings" size={iconSize} className="text-white" />
            </button>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div
        className="relative z-10 mx-auto"
        style={{
          maxWidth: 'clamp(320px, 92vw, 1100px)',
          padding: 'clamp(12px, 2vw, 32px) clamp(12px, 2.5vw, 40px)',
          paddingBottom: 'clamp(80px, 12vw, 160px)'
        }}
      >
        {/* Roulette Wheel */}
        <div style={{ marginBottom: 'clamp(20px, 4vw, 64px)' }}>
          <RouletteWheel
            prizes={mockPrizes}
            onSpinComplete={handleSpinComplete}
            isSpinning={isSpinning}
            setIsSpinning={setIsSpinning}
            mode={mode}
            triggerSpin={triggerSpin}
            onSpinStart={handleSpinStart}
            primaryColor={config?.colors?.primary || '#0d9488'}
            secondaryColor={config?.colors?.secondary || '#2dd4bf'}
          />
          {/* Legend */}
          <div
            className="text-center"
            style={{ marginTop: 'clamp(12px, 2vw, 32px)' }}
          >
            <p
              className="font-semibold text-white/90"
              style={{
                fontSize: 'clamp(12px, 1.8vw, 26px)',
                textShadow: '0 1px 4px rgba(0,0,0,0.5)',
                letterSpacing: '0.03em'
              }}
            >
              Premios Válidos hasta agotar existencias
            </p>
          </div>
        </div>
      </div>
      {/* Admin Portal */}
      {showAdminPortal && (
        <AdminAccessPortal
          onClose={() => setShowAdminPortal(false)}
          onAuthenticate={handleAuthenticate}
        />
      )}
      {/* Game Controls (Assisted Mode) */}
      {showGameControls && isAuthenticated && (
        <GameControlInterface
          onClose={() => setShowGameControls(false)}
          onManualSpin={handleManualSpin}
          isSpinning={isSpinning}
          mode={mode}
          onModeChange={handleModeChange}
        />
      )}
      {/* Instructions Modal */}
      {showInstructions && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center"
          style={{ padding: 'clamp(12px, 2vw, 32px)' }}
          onClick={() => setShowInstructions(false)}
        >
          <div
            className="bg-white rounded-2xl shadow-2xl w-full"
            style={{ maxWidth: 'clamp(300px, 80vw, 900px)', padding: 'clamp(20px, 4vw, 64px)' }}
            onClick={(e) => e?.stopPropagation()}
          >
            <div className="flex items-center justify-between" style={{ marginBottom: 'clamp(16px, 3vw, 40px)' }}>
              <h2
                className="font-black text-[#1e40af]"
                style={{ fontSize: 'clamp(18px, 3vw, 52px)' }}
              >
                INSTRUCCIONES
              </h2>
              <button
                onClick={() => setShowInstructions(false)}
                className="text-gray-500 hover:text-gray-700 touch-manipulation"
                style={{ width: 'clamp(32px, 4vw, 60px)', height: 'clamp(32px, 4vw, 60px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <Icon name="X" size={Math.max(20, Math.round(window.innerWidth * 0.025))} />
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(12px, 2vw, 28px)' }}>
              {[
                'Toca el botón central "¡GIRA AQUI!" para hacer girar la ruleta',
                'Espera a que la ruleta se detenga en tu premio',
                'Presenta tu código de premio en el stand XAIKUS',
                '¡Disfruta de tu premio! Todos los premios son válidos hasta febrero 2026'
              ]?.map((text, i) => (
                <div key={i} className="flex items-start" style={{ gap: 'clamp(10px, 1.5vw, 22px)' }}>
                  <div
                    className="bg-[#1e40af] text-white rounded-full flex items-center justify-center font-bold flex-shrink-0"
                    style={{
                      width: 'clamp(28px, 4vw, 60px)',
                      height: 'clamp(28px, 4vw, 60px)',
                      fontSize: 'clamp(12px, 1.6vw, 26px)'
                    }}
                  >
                    {i + 1}
                  </div>
                  <p
                    className="text-gray-700"
                    style={{ fontSize: 'clamp(13px, 1.8vw, 30px)', paddingTop: 'clamp(2px, 0.5vw, 8px)' }}
                  >
                    {text}
                  </p>
                </div>
              ))}
            </div>
            <button
              onClick={() => setShowInstructions(false)}
              className="w-full bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold rounded-xl transition-colors touch-manipulation"
              style={{
                marginTop: 'clamp(20px, 3vw, 48px)',
                height: 'clamp(44px, 6.5vw, 96px)',
                fontSize: 'clamp(14px, 2vw, 34px)'
              }}
            >
              ENTENDIDO
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RouletteGameScreen;